import { render, staticRenderFns } from "./walletOverdrawSettings.vue?vue&type=template&id=8fcddb7e&scoped=true&"
import script from "./walletOverdrawSettings.vue?vue&type=script&setup=true&lang=js&"
export * from "./walletOverdrawSettings.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./walletOverdrawSettings.vue?vue&type=style&index=0&id=8fcddb7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcddb7e",
  null
  
)

export default component.exports